//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
import helpBanner from '~/components/help/helpBanner.vue' // 面包屑
export default {
  components: {
    'help-banner': helpBanner
  },
  layout (context) {
    return context.route.query?.type ? 'empty' : 'default'
  },
  async asyncData ({ $api, store, redirect, route, params }) {
    const { locale = 'en', countryCode } = store.state
    const code = params?.id?.replace('.html', '')
    // 获取tab数据
    const res = await $api.common.v3Server({ Routes: 'wikifxarticle$vpsarticleinfo', BasicData: store.getters?.getDiffBasic }, { languageCode: locale, countryCode, code, platform: 1, upStreamIp: '404' }).catch(() => {})
    const contentObj = res.wikifxarticle.vpsarticleinfo.data || {}
    return { contentObj }
  },
  data () {
    return {
      isApp: this.$route.query?.type || 0,
      contentObj: {}
    }
  },
  computed: {
    ...mapState(['suffix'])
  },
  mounted () {
    this.$nextTick(() => {
      this.getOpen()
    })
  },
  methods: {
    getOpen () {
      const dom = document.querySelectorAll('.content-box a')
      dom.forEach((item) => {
        item.addEventListener('click', (item1) => {
          item1.preventDefault()
          if (this.isApp) {
            if (item.href.includes(`vps.wikifx.${this.suffix}`)) return window.open(item.href + '?type=1')
            else return window?.Communication('webOutboundBrowser', JSON?.stringify({ url: item.href }))
          } else {
            window.open(item.href)
          }
        })
      })
    }
  }
}
